import { translateObjectByDictionary } from "../utilities/Utility";

const writeDictionaries = (objectType) => {
	return {
		tableName: tableName(objectType),
		fields: fields(objectType)
	}

	function tableName(type) {
		switch (type) {
			case 'primary':
			case 'secondary':
				return '@TSD_DISPATCHTRANS';
			case 'work':
				return '@TSDTRANS_WORK';
			case 'labor':
				return '@TSDTRANS_LABOR';
			case 'container':
				return '@TSDTRANS_CONT';
			case 'material':
				return '@TSDTRANS_MAT';
			case 'note':
				return '@TSNOTE';
			case 'user':
				return '@TSUSERS'
			case 'scheduleRowTerritory':
				return '@TSROWSCHEDULE';
			case 'taxException':
				return '@TSFCUSTOMTAX';
			case 'taxAuthority':
				return '@TSFTAXAUTHORITY';
			case 'taxGroup':
				return '@TSFTAXAPPLYGROUP';
			case 'taxRate':
				return '@TSFTAXRATE';
			case 'pmProject':
				return '@PM_PROJECTS';
			case 'pmPhase':
				return '@PM_PHASES';
			case 'pmTaskGroup':
				return '@PM_TASKGROUPS';
			case 'pmTask':
				return '@PM_TASKS';
			case 'pmHourLine':
				return '@PM_HOURS';
			case 'pmSubTask':
				return '@PM_SUBTASKS';
			case 'pmComment':
				return '@PM_COMMENTS';
			default:
				return '';
		}
	}

	function fields(type) {
		switch (type) {
			case 'primary':
			case 'secondary':
				return {
					foreignID: 'U_ParentKey',
					uniqueID: 'U_UniqueID',
					subType: 'U_SubType',
					subTypeKey: 'U_SubTypeKey',
					startTime: 'U_StartTime',
					endTime: 'U_EndTime',
					scheduled: 'U_Active'
				};
			case 'work':
			case 'labor':
			case 'container':
			case 'material':
				return {
					foreignID: 'U_ParentKey',
					uniqueID: 'U_UniqueID',
					subType: 'U_SubType',
					subTypeKey: 'U_SubTypeKey',
					scheduled: 'U_Active'
				};
			case 'note':
				return {
					parentType: 'U_ParentType',
					parentKey: 'U_ParentKey',
					parentSubType: 'U_ParentSubType',
					parentSubKey: 'U_ParentSubKey',
					note: 'U_Note',
					noteType: 'U_NoteType',
					updatedBy: 'U_UpdatedBy',
					updateDate: 'U_UpdatedDate',
					updateTime: 'U_UpdatedTime',
					active: 'U_Active'
				};
			case 'user':
				return {
					firstName: 'U_FirstName',
					lastName: 'U_LastName',
					userName: 'U_Username',
					dispatchUserType: 'U_DispatchUserType',
					active: 'U_Active'
				}
			case 'scheduleRowTerritory':
				return {
					active: 'U_Active',
					territory: 'U_TerritoryCode',
					rowKey: 'U_RowCode'
				}
			case 'taxException':
				return {
					active: 'U_Active',
					adjustment: 'U_Adjustment',
					taxCode: 'U_TaxCode',
					taxGroup: 'U_GroupCode',
					shipTo: 'U_ShipTo',
					cardCode: 'U_CardCode'
				}
			case 'taxAuthority':
				return {
					taxCode: 'U_TaxCode',
					authorityType: 'U_AuthCode',
					standardTax: 'U_StandardTax',
					country: 'U_Country',
					state: 'U_State',
					county: 'U_County',
					city: 'U_City'
				}
			case 'taxGroup':
				return {
					taxCode: 'U_TaxCode',
					groupCode: 'U_GroupCode'
				}
			case 'taxRate':
				return {
					taxCode: 'U_TaxCode',
					rate: 'U_Rate',
					dateStart: 'U_DateStart'
				}
			case 'pmBP':
				return {
					// TODO
				};
			case 'pmContacts':
				return {
					// TODO
				};
			case 'pmProject':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					display: 'U_Display',
					description: 'U_Description',
					bp: 'U_BusinessPartner',
					status: 'U_Status',
					assigned: 'U_Assigned',
					//phases: 'U_Phases',
					//phase: 'U_Phase',
					//attachments: 'U_Attachments'
				};
			case 'pmPhase':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					display: 'U_Display',
					description: 'U_Description',
					bp: 'U_BusinessPartner',
					status: 'U_Status',
					assigned: 'U_Assigned',
					contacts: 'U_Contacts',
					project: 'U_Project',
					//attachments: 'U_Attachments'
					//taskGroups: 'U_taskGroups',
				};
			case 'pmTaskGroup':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					display: 'U_Display',
					description: 'U_Description',
					bp: 'U_BusinessPartner',
					project: "U_Project",
					status: 'U_Status',
					assigned: 'U_Assigned',
					dueDate: 'U_DueDate',
					tasks: 'U_Tasks',
					//phase: 'U_Phase',
				};
			case 'pmTask':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					display: 'U_Display',
					description: 'U_Description',
					bp: 'U_BusinessPartner',
					project: "U_Project",
					//phase: 'U_Phase',
					phaseID: 'U_PhaseID',
					status: 'U_Status',
					U_GeneralNotes: 'generalNotes',
					U_DevNotes: 'devNotes',
					U_LeadNotes: 'leadNotes',
					assigned: 'U_Assigned',
					comments: 'U_Comments',
					hourLines: 'U_HourLines',
					subTasks: 'U_SubTasks',
					window: 'U_Window',
				};
			case 'pmHourLine':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					workDate: 'U_WorkDate',
					addedDate: 'U_AddedDate',
					createdBy: 'U_CreatedBy',
					note: 'U_Note',
					internal: 'U_Internal',
					hours: 'U_Hours',
					planned: 'U_Planned',
					billable: 'U_Billable',
					billed: 'U_Billed',
				};
			case 'pmSubTask':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					createdBy: 'U_CreatedBy',
					title: 'U_Title',
					comment: 'U_Comment',
					checked: 'U_Checked'
				};
			case 'pmComment':
				return {
					parentID: 'U_ParentID',
					uniqueID: 'U_UniqueID',
					createdBy: 'U_createdBy',
					date: 'U_Date',
					time: 'U_Time',
					comment: 'U_Comment'
				};
			default:
				return {};
		}
	}
};

export const writePrecursorXMLLines = (type, lines) => {
	const confToUse = writeDictionaries(type);
	let base = {
		'UserTableEntry': {
			'AcceptsNullsAndEmptyStrings': '',
			'Name': confToUse.tableName,
			'Row': lines.map((line) => {
				return createRowObject(line, confToUse);
			})
		}
	}
	return base;
}

export const writePrecursorXMLSingle = (obj) => {
	const confToUse = writeDictionaries(obj.type);
	let base = {
		'UserTableEntry': {
			'AcceptsNullsAndEmptyStrings': '',
			'Name': confToUse.tableName,
			'Row': createRowObject(obj, confToUse)
		}
	}
	return base;
};

function createRowObject(obj, confToUse) {
	let returnObj = {};
	if (obj.key !== null) {
		returnObj.Key = obj.key;
	}
	returnObj.Fields = translateObjectByDictionary(obj, confToUse.fields);
	return returnObj;
}



// WEBPACK FOOTER //
// ./src/writes/udo.js